<template>
	<div class="concept">
		<h3 class="my-5">Document</h3>
		<v-card
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div>
					<v-icon class="p-1" color="primary">mdi-file</v-icon><a :href="documents.user_guide.path" target="_BLANK">{{ documents.user_guide.name }}</a>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div>
					<v-icon class="p-1" color="primary">mdi-file</v-icon><a :href="documents.incharge_manual.path" target="_BLANK">{{ documents.incharge_manual.name }}</a>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div>
					<v-icon class="p-1" color="primary">mdi-file</v-icon><a :href="documents.key_function_incharge.path" target="_BLANK">{{ documents.key_function_incharge.name }}</a>
				</div>
			</div>
		</v-card>
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		name: 'concept',
		components: {
		},
		data:function(){
			return{
				documents:{
					user_guide: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-User_Guide.pdf',
						name: 'User Guide',
					},
					incharge_manual: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Incharge_Manual.pdf',
						name: 'User Manual (School Incharge)',
					},
					key_function_incharge: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Key_Functions_of_Incharge.pdf',
						name: 'Key Functions Manual (School Incharge)',
					}
				},
			}
		},
		mounted: function(){
			var self = this;
		},
		methods:{
		}
	}
</script>
